import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import classnames from 'classnames';

import {
    Col,
    Form,
    Checkbox,
    FormControl,
    FormGroup,
    ControlLabel,
    Button
} from 'react-bootstrap';

import {
    validateEmail,
    settingsChangedAction,
    settingsEmailChanged,
    settingsRequestToChangeEmail
} from '../../actions/SettingsActions';


const mapStateToProps = (state) => ({
    ...state.settingsReducer,
    primaryEmail: state.meReducer.me.primaryEmail,
    emails: state.meReducer.me.emails,
    event: state.eventReducer.event,
    emailValid: true
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
    validateEmail,
    settingsChangedAction,
    settingsEmailChanged,
    settingsRequestToChangeEmail
}, dispatch);


class ChangeEmailView extends Component {

    constructor() {
        super();
        this.state = {
            showErrorMessage: false,
            emailSent: false,
            isEmailValid: true,
            errorMessage: ''
        };
    }

    isEmailValid(email) {
        var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    inputChanged = (e) => {
        const value = e.target.value;
        const errorMessage = this.isEmailNotValid(value);
        this.setState({email: value, isEmailValid: !errorMessage, errorMessage: errorMessage});
        this.props.settingsEmailChanged({emailToChangeTo: value});
    }

    changeEmail = () => {
        const {isEmailValid} = this.state;
        if (!isEmailValid) {
            return;
        }
        this.props.settingsRequestToChangeEmail().then(() => {
            this.setState({emailSent: true});
        }).catch((e) => {
            this.setState({showErrorMessage: true});
            setTimeout(() => {
                this.setState({showErrorMessage: false});
            }, 3000);
        });
    }

    isEmailNotValid = (email = '') => {
        const {emails, primaryEmail} = this.props;
        let errorMessage;
        if (email === primaryEmail) {
            return 'This is your email already';
        }
        if (emails.indexOf(email) > -1) {
            errorMessage = 'This is already one of your secondary emails';
        }
        if (!this.isEmailValid(email)) {
            errorMessage = 'Email is not valid';
        }
        return errorMessage;
    }

    render() {
        const {primaryEmail, emailToChangeTo} = this.props;
        const {isEmailValid, showErrorMessage, emailSent, errorMessage} = this.state;
        const error = primaryEmail !== '' && isEmailValid === false;

        if (emailSent) {
            return <div className="change-email-container container text-center">
                <h1><strong>Change Email</strong></h1>
                <h4 className="margin-top-small">Email sent to {emailToChangeTo}</h4>
                <h4 className="margin-bottom-small">Follow the instructions inside</h4>
            </div>;
        }
        return (
            <div className="change-email-container container text-center">
                <h1><strong>Change Email</strong></h1>
                <h4 className="margin-top-small">{`Enter a new email address for ${primaryEmail}`}</h4>
                <h4 className="margin-bottom-small">Changing the email address affects your login email and your address
                    for incoming notifications</h4>

                <Form horizontal>
                    <Col xs={12}>
                        <FormGroup
                            controlId="formBasicText">
                            <FormControl className="email-input"
                                type="text"
                                placeholder="New Email Address"
                                onBlur={this.inputChanged}
                            />
                            <FormControl.Feedback/>
                            <label className={classnames('error', {
                                'error-visible': error,
                                'error-hidden': !error
                            })}>{error ? errorMessage : showErrorMessage ? 'Could not change email' : ''}</label>
                        </FormGroup>
                    </Col>

                    <Button className="change-email-button margin-top-medium" onClick={this.changeEmail}
                        disabled={!isEmailValid}>
                        Change Email
                    </Button>
                    <Col xs={12}>
                        <img className="change-email-image" src="/images/change_email/change.png" alt=""/>
                    </Col>
                </Form>
            </div>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ChangeEmailView);
